'use strict';

window.process = {
    env: {
        NODE_ENV: 'development'
    }
}

// --- Integrations ---
import './integrations/bootstrap'; // integrates some bootstrap classes into wordpress
import "./integrations/aos"  // required npm package: 'aos'
import "./integrations/swiper"  // required npm package: 'swiper'
import "./integrations/fancybox"

// --- Custom components ---

import './components/vertical';
import './components/modal';
import './components/timeline';
import './components/tabs';
import './components/navs';
import './components/backtotop';
import './components/category-filter';
import './components/scheme';
import './components/contact-form';
import './header/headerscroll';
